<template>
  <div class="space-y-6 max-w-3xl mx-auto">
    <div class="flex items-center justify-between">
      <h1 class="text-xl font-semibold">จัดการผู้ใช้</h1>
      <div class="flex items-center gap-2">
        <span class="text-sm text-slate-500">สวัสดี, {{ auth.user?.username }}</span>
        <button class="btn-outline" @click="logout">ออกจากระบบ</button>
      </div>
    </div>

    <div class="card space-y-3">
      <h2 class="font-medium">สร้างผู้ใช้ใหม่</h2>
      <div class="grid md:grid-cols-3 gap-3">
        <input class="input" placeholder="ชื่อผู้ใช้" v-model="form.username" />
        <input class="input" placeholder="รหัสผ่าน" type="password" v-model="form.password" />
        <select class="input" v-model="form.role">
          <option value="admin">admin</option>
          <option value="superadmin">superadmin</option>
        </select>
      </div>
      <div class="flex items-center gap-3">
        <button class="btn-primary" :disabled="creating" @click="createUser">
          {{ creating ? 'กำลังสร้าง...' : 'สร้างผู้ใช้' }}
        </button>
        <span v-if="error" class="text-sm text-red-600">{{ error }}</span>
      </div>
    </div>

    <div class="card">
      <h2 class="font-medium mb-3">รายการผู้ใช้</h2>
      <div class="overflow-x-auto">
        <table class="table">
          <thead>
            <tr class="th">
              <th class="th text-left">ID</th>
              <th class="th text-left">Username</th>
              <th class="th text-left">Role</th>
              <th class="th text-left">Created At</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="u in users" :key="u.id">
              <td class="td">{{ u.id }}</td>
              <td class="td">{{ u.username }}</td>
              <td class="td"><span class="badge">{{ u.role }}</span></td>
              <td class="td">{{ new Date(u.created_at).toLocaleString() }}</td>
            </tr>
            <tr v-if="!users.length">
              <td class="td text-center text-slate-500" colspan="4">
                {{ loading ? 'กำลังโหลด...' : 'ยังไม่มีผู้ใช้' }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import api from '../../api/http'
import { useAuth } from '../../stores/auth'
import { useRouter } from 'vue-router'

const auth = useAuth()
const router = useRouter()

const form = ref({ username: '', password: '', role: 'admin' })
const creating = ref(false)
const error = ref('')
const users = ref([])
const loading = ref(false)

async function loadUsers() {
  loading.value = true
  try {
    const { data } = await api.get('/auth/users', {
      headers: { 'X-CSRF-Token': auth.csrfToken },
      withCredentials: true
    })
    users.value = data.data || []
  } finally {
    loading.value = false
  }
}

async function createUser() {
  error.value = ''
  if (!form.value.username || !form.value.password) {
    error.value = 'กรอกชื่อผู้ใช้และรหัสผ่าน'
    return
  }
  creating.value = true
  try {    
    await api.post('/auth/users', form.value)
    form.value = { username: '', password: '', role: 'admin' }
    await loadUsers()
  } catch (e) {
    error.value = e.response?.data?.error || 'สร้างผู้ใช้ไม่สำเร็จ'
  } finally {
    creating.value = false
  }
}

async function logout() {
  await auth.logout()
  router.push('/admin')
}

onMounted(async () => {
  await auth.check()
  if (!auth.isAuthed) router.push('/admin')
  else await loadUsers()
})
</script>
